import { useState } from "react";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { CalendarDays, X } from "lucide-react";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { cn } from "../lib/utils";

/**
 * DateField — sélecteur de date en français (calendrier shadcn / react-day-picker).
 * value : chaîne ISO "yyyy-MM-dd" (ou "") — onChange reçoit le même format.
 */
export function DateField({ value, onChange, placeholder = "Choisir une date", className, testId = "date-field", fromYear = 1950, toYear = 2035 }) {
  const [open, setOpen] = useState(false);
  const date = value ? new Date(`${value}T00:00:00`) : undefined;
  const valid = date && !isNaN(date.getTime());

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          className={cn(
            "w-full flex items-center gap-2 bg-[#0b0811] border border-white/10 rounded-lg px-3 py-2 text-sm text-left transition-colors hover:border-[#f7c935]/40",
            valid ? "text-white" : "text-slate-500",
            className,
          )}
        >
          <CalendarDays className="w-4 h-4 text-[#f7c935] flex-shrink-0" />
          <span className="flex-1 truncate">
            {valid ? format(date, "d MMMM yyyy", { locale: fr }) : placeholder}
          </span>
          {valid && (
            <span
              role="button"
              tabIndex={0}
              aria-label="Effacer la date"
              data-testid={`${testId}-clear`}
              onClick={(e) => { e.stopPropagation(); onChange(""); }}
              onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); e.stopPropagation(); onChange(""); } }}
              className="text-slate-500 hover:text-white"
            >
              <X className="w-3.5 h-3.5" />
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto p-0 bg-[#14101c] border-white/10 text-white">
        <Calendar
          mode="single"
          locale={fr}
          selected={valid ? date : undefined}
          defaultMonth={valid ? date : undefined}
          captionLayout="dropdown-buttons"
          fromYear={fromYear}
          toYear={toYear}
          weekStartsOn={1}
          onSelect={(d) => {
            onChange(d ? format(d, "yyyy-MM-dd") : "");
            setOpen(false);
          }}
          classNames={{
            caption_dropdowns: "flex gap-1 items-center",
            caption_label: "hidden",
            dropdown: "bg-[#0b0811] text-white text-xs rounded-md border border-white/10 px-1.5 py-1 outline-none",
            dropdown_month: "", dropdown_year: "",
            vhidden: "hidden",
            day_selected: "bg-[#f7c935] text-[#14101c] hover:bg-[#e6b825] focus:bg-[#f7c935]",
            day_today: "border border-[#f7c935]/50",
          }}
        />
      </PopoverContent>
    </Popover>
  );
}
